<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="12" size-md="6" size-lg="5" size-xs="12" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img (click)="onClickGoToIncrementPage()" src="././assets/icon/backArrow.svg" class="cp">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp">Increment</span> / <span [style.color]="buttonColorName">Generate increment
            letters</span></label>
      </div>
    </ion-col>
  </ion-row>
  <div class="modal-body p-20">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="fs-16 font_regular">Increment letters ({{lettercouent}})</div>
      </ion-col>
    </ion-row>

    <ion-row class="pt-15">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
        <div class="d-flex inputFieldsGroup">
          <ng-multiselect-dropdown class="ml-5 w250 mat-height40 fs-10" [placeholder]="'Select Department'"
            [settings]="dropdownSettings" [data]="getDepartmentsList" [(ngModel)]="selectedDepartment"
            (onSelect)="onSelectDepartment()" (onDeSelect)="onDeSelectDepartment()"
            (onSelectAll)="selectAllDepartment($event)" (onDeSelectAll)="onDeSelectAllDepartment()">
          </ng-multiselect-dropdown>

          <ng-multiselect-dropdown class="ml-5 w250 mat-height40" [placeholder]="'Select Band'"
            [settings]="dropdownSettings" [data]="getBandList" [(ngModel)]="selectedBand" (onSelect)="onSelectdBand()"
            (onDeSelect)="onDeSelectdBand()" (onSelectAll)="selectAllBand($event)"
            (onDeSelectAll)="onDeSelectAllBand()">
          </ng-multiselect-dropdown>

          <ng-multiselect-dropdown class="ml-5 w250 mat-height40" [placeholder]="'Select Manager'"
            [settings]="dropdownSettings" [data]="getManagerList" [(ngModel)]="selectedManager"
            (onSelect)="onSelectdManager()" (onDeSelect)="onDeSelectdManager()" (onSelectAll)="selectAllManager($event)"
            (onDeSelectAll)="onDeSelectAllManager()">
          </ng-multiselect-dropdown>

          <ng-multiselect-dropdown class="ml-5 w250 mat-height40" [placeholder]="'Select Employee'"
            [settings]="dropdownSettings" [data]="getEmployeeList" [(ngModel)]="selectedEmployee"
            (onSelect)="onSelectdEmployee()" (onDeSelect)="onDeSelectdEmployee()"
            (onSelectAll)="selectAllEmployee($event)" (onDeSelectAll)="onDeSelectAllEmployee()">
          </ng-multiselect-dropdown>

          <ng-multiselect-dropdown class="ml-5 w250 mat-height40" [placeholder]="'Select Rating'"
            [settings]="dropdownSettings" [data]="getRatingData" [(ngModel)]="selectedRating"
            (onSelect)="onSelectdRating()" (onDeSelect)="onDeSelectdRating()" (onSelectAll)="selectAllRating($event)"
            (onDeSelectAll)="onDeSelectAllRating()">
          </ng-multiselect-dropdown>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="pt-15">
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="d-flex">
          <mat-form-field class="mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchGenerateIncrementTableData"
              (input)="onGenerateIncrementSearch(searchGenerateIncrementTableData)">
          </mat-form-field>
          <ion-label class="center-content ml-10 fs-14 font_medium pr-10 black_color">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select [value]="25">
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="center-content fs-14 font_medium pl-10 black_color">entries</ion-label>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="horizontal-row"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="selectDownload">
          <div class="select-comgination-checkbox">
            <section class="mat-checkbox-style">
              <mat-checkbox [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()">Select All</mat-checkbox>
            </section>
          </div>
          <div *ngIf="isShowDownloadBtn">
            <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="downloadSelected()">
              <span class="material-icons">download</span>
            </button>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="d-flex" style="gap: 16px;">
        <div class="card-container">
          <div class="cardBox" *ngFor="let data of incrementLetterData; let id = index">
            <div>
              <section class="mat-checkbox-style fs-12">
                <mat-checkbox [(ngModel)]="data.isChecked" 
                  (change)="onCheckboxChange()">{{data.employeeName}}</mat-checkbox>
              </section>
            </div>
            <div class="cartContent">
              <span class="material-icons fs-12 text_blue">visibility</span><span class="fs-12 text_blue cp"
                (click)="onClickPreviewLetter(data.employeeName, data.inputId)"> Preview</span> <span class="fs-12 text_gray1"> | </span>
              <span class="fs-14 cl-black">Incre - {{data.hrAndMdIncrementPercentage || '0'}}%</span>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-content>